import type { SVGProps } from 'react';
const SvgIconStack = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      d="m14.107 8.981.106.067a1.75 1.75 0 0 1 0 2.905l-.106.066-4.243 2.429a3.75 3.75 0 0 1-3.727 0l-4.243-2.429c-1.174-.672-1.174-2.366 0-3.038l.707-.405 1.51.864-1.472.843a.25.25 0 0 0 0 .434l4.243 2.43a2.25 2.25 0 0 0 2.236 0l4.244-2.43.054-.043a.25.25 0 0 0 0-.348l-.054-.043-1.473-.843 1.51-.864z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.357 1.436a3.75 3.75 0 0 1 3.507.116l4.243 2.43.106.066a1.75 1.75 0 0 1 0 2.905l-.106.066-4.243 2.429a3.75 3.75 0 0 1-3.727 0L1.894 7.019C.72 6.347.72 4.653 1.894 3.981l4.243-2.429zm2.761 1.418a2.25 2.25 0 0 0-2.104-.07l-.132.07L2.64 5.283a.25.25 0 0 0 0 .434l4.243 2.43a2.25 2.25 0 0 0 2.236 0l4.244-2.43.054-.043a.25.25 0 0 0 0-.348l-.054-.043z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIconStack;
